import React from 'react';
import { motion } from 'framer-motion';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useConfigSection } from '../utils/useConfig';

type SocialMediaIconsProps = {
  className?: string;
  showLabels?: boolean;
  iconSize?: 'small' | 'medium' | 'large';
  columnLayout?: boolean;
  message?: string;
};

const SocialMediaIcons: React.FC<SocialMediaIconsProps> = ({
  className = '',
  showLabels = false,
  iconSize = 'medium',
  columnLayout = false,
  message = 'Znajdź nas tutaj:',
}) => {
  const social = useConfigSection('social');

  // Przygotowanie listy mediów społecznościowych
  const socialLinks = [
    ...(social.facebook
      ? [
          {
            name: 'Facebook',
            url: social.facebook,
            icon: <FacebookIcon fontSize={iconSize} />,
            color: 'hover:bg-blue-600',
          },
        ]
      : []),
    ...(social.instagram
      ? [
          {
            name: 'Instagram',
            url: social.instagram,
            icon: <InstagramIcon fontSize={iconSize} />,
            color: 'hover:bg-pink-600',
          },
        ]
      : []),
    ...(social.youtube
      ? [
          {
            name: 'YouTube',
            url: social.youtube,
            icon: <YouTubeIcon fontSize={iconSize} />,
            color: 'hover:bg-red-600',
          },
        ]
      : []),
    ...(social.twitter
      ? [
          {
            name: 'Twitter',
            url: social.twitter,
            icon: <TwitterIcon fontSize={iconSize} />,
            color: 'hover:bg-blue-400',
          },
        ]
      : []),
    ...(social.linkedin
      ? [
          {
            name: 'LinkedIn',
            url: social.linkedin,
            icon: <LinkedInIcon fontSize={iconSize} />,
            color: 'hover:bg-blue-800',
          },
        ]
      : []),
  ];

  if (socialLinks.length === 0) return null;

  return (
    <div className="mt-auto">
      <p className="text-gray-800 font-medium mb-3">{message}</p>
      <div
        className={`flex space-x-3 ${columnLayout ? 'flex-col' : 'flex-row'} ${className}`}
      >
        {socialLinks.map((social, index) => (
          <div className="flex flex-col items-center" key={index}>
            <motion.a
              key={index}
              href={social.url}
              className={`w-10 h-10 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center transition-colors ${social.color} hover:text-white`}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              aria-label={`Odwiedź nasz profil na ${social.name}`}
            >
              {social.icon}
            </motion.a>
            {showLabels && (
              <span className="text-sm text-gray-600">{social.name}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialMediaIcons;
